'use strict';
import * as firebase from "firebase/app";

import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

const confName = process.env.FIREBASE_KEY; //firebase-cli does set FIREBASE_KEY
let conf;
// firebase-cli sets a variable named FIREBASE_CONFIG to currently set project.
// webpack DefinePlugin will replace this string automatically
// to force development mode
if (confName === "testing"){
  // "testing" configuration
  conf = {
    apiKey: "AIzaSyClNk1hOBVuYLIMtQTDHbLjgtvfMfYTgyc",
    authDomain: "holusion-ptest.firebaseapp.com",
    databaseURL: "https://holusion-ptest.firebaseio.com",
    projectId: "holusion-ptest",
    storageBucket: "holusion-ptest.appspot.com",
    uploadBucket: "gs://upload-holusion-ptest",
    messagingSenderId: "1036950964787"
  };
}else{
  conf = {
    apiKey: "AIzaSyAoAagPKzqRskYMVQXF_3swu-us-hd0Xks",
    authDomain: "holusion-pixel.firebaseapp.com",
    databaseURL: "https://holusion-pixel.firebaseio.com",
    projectId: "holusion-pixel",
    storageBucket: "holusion-pixel.appspot.com",
    uploadBucket: "gs://upload-holusion-pixel",
    messagingSenderId: "297805564521"
  };
}
//console.log("Use config : ", conf);
const app = firebase.initializeApp(conf);
export default app;
export function getModule(){return firebase};
